module.exports = __webpack_public_path__ + "02_mid_black.8e219522.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/02_mid_black.png
// module id = s029
// module chunks = 0